<template>
  <div class="container">
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix">
        <h1>商品清单列表</h1>
      </div>
      <el-table border :data="orderArr" style="width: 100%" size="mini">
        <el-table-column property="warehouseUserName" label="供应商" width="160">
          <span slot-scope="scope">
            {{ scope.row.warehouseUserName }}
          </span>
        </el-table-column>
        <el-table-column prop="name" label="图书信息">
          <template slot-scope="scope">
            <el-row align="left">
              <el-col :span="6">
                <el-popover placement="right" trigger="hover">
                  <el-image slot="reference" style="width: 36px; height: 36px" :src="scope.row.productImg"
                    fit="cover" />
                  <el-image style="width: 220px; height: 220px" :src="scope.row.productImg" fit="cover" />
                </el-popover>
              </el-col>
              <el-col :span="16" :pull="2">{{ scope.row.productName }}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="productSn" label="ISBN" width="180">
        </el-table-column>
        <!-- <el-table-column
          prop="vipPrice"
          label="折扣价"
          width="100"
        ></el-table-column> -->
        <el-table-column prop="marketPrice" label="定价" width="100"></el-table-column>
        <el-table-column prop="discount" label="折扣" width="100"></el-table-column>
        <el-table-column prop="shopPrice" label="折扣价" width="100"></el-table-column>
        <el-table-column prop="productNumber" label="数量" width="100"></el-table-column>
      </el-table>
      <div class="total">
        <el-row>
          <el-col :span="4">
            <h2>
              原价(合计)：<span class="red">￥{{ cartTotalMarketPrice }}</span>
            </h2>
          </el-col>
          <el-col :span="4">
            <h2>
              折扣价(合计)：<span class="red">￥{{ cartTotalShopPrice }}</span>
            </h2>
          </el-col>
          <el-col :span="4">
            <h2>
              数量(合计)：<span class="red">{{ cartTotalNum }}</span>
            </h2>
          </el-col>
          <el-col :span="4">
            <h2>
              总价(合计)：<span class="red">￥{{ cartTotalPrice }}</span>
            </h2>
          </el-col>
          <!-- <el-col :span="8"  style="text-align: right"><el-button type="danger">去支付</el-button></el-col> -->
        </el-row>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="display: flex;">
        <h1 style="flex:1;">收货地址</h1>
        <el-checkbox-button @change="isdaifahuo" v-model="dfhchecked">
          代发货
        </el-checkbox-button>
      </div>
      <div v-show="isdfht">
        <el-table border :data="addressList" style="width: 100%;flex:1;" size="small">
          <el-table-column label="" width="40">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="currentRow" @change.native="getCurrentRow(scope.row)"
                style="color: #fff; padding-left: 5px; margin-right: -25px"></el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="consignee" label="收货人"></el-table-column>
          <el-table-column label="收货地址">
            <template slot-scope="scope">
              {{ scope.row.provinceText }}{{ scope.row.cityText
              }}{{ scope.row.districtText }} {{ scope.row.address }}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="联系方式"></el-table-column>
        </el-table>
      </div>
      <div v-show="isdfh">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <span>添加新地址</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-input type="textarea" :rows="6" placeholder="粘贴如：北京市朝阳区xx路xx号，王xx，136xxxxxxxx" v-model="textarea"
              class="tarea" @input="inputChangeAddrFunc">
            </el-input>
            <el-button type="primary" @click="text">确定</el-button>
          </el-col>
          <el-col :span="14">
            <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
              <el-form-item label="姓名" prop="consignee">
                <el-input v-model="ruleForm.consignee" placeholder="收货人姓名"></el-input>
              </el-form-item>
              <el-form-item label="联系方式" prop="mobile">
                <el-input v-model="ruleForm.mobile" placeholder="收货人手机号"></el-input>
              </el-form-item>
              <el-form-item label="地区" prop="district">
                <v-distpicker :province="select.province" :city="select.city" :area="select.district"
                  @selected="onSelected"></v-distpicker>
              </el-form-item>
              <el-form-item label="详细地址" prop="address">
                <el-input v-model="ruleForm.address" placeholder="详细地址"></el-input>
              </el-form-item>
              <el-form-item label="邮编" prop="zipcode">
                <el-input v-model="ruleForm.zipcode" placeholder="邮政编码"></el-input>
              </el-form-item>
              <el-form-item label="运费" prop="expenses">
                <el-input v-model="ruleForm.expenses" :disabled="true"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="display: flex;">
        <h1 style="flex:1;">支付方式</h1>
      </div>
      <div>
        <el-radio v-model="payType" label="1">余额支付</el-radio>
        <!-- <el-radio v-model="payType" label="2">支付宝支付</el-radio> -->
      </div>
    </el-card>
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="display: flex;">
        <h2 style="flex:1;">配货要求(备注)</h2>
      </div>
      <div>
        <div v-if="currUserNumber < 0" style="display: inline-block; font-size: 14px; margin-bottom: 10px; margin-right: 20px">
          订单公司 <el-input placeholder="可简称，但同一公司需保持一致" size="mini" style="width: 200px; "
            v-model="orderCompany"></el-input>
          <!-- <el-select
            v-model="orderCompany"
            filterable
            placeholder="选择订单所属公司"
            style="width: 240px"
            size="mini"
          >
            <el-option
              v-for="item in companyOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            />
          </el-select> -->
        </div>
        <div style="display: inline-block; font-size: 14px; margin-bottom: 10px;">
          包标 <el-input placeholder="包标内容" size="mini" style="width: 200px; margin-left: 10px;"
            v-model="labelNote"></el-input>
        </div>
        <br>
        <el-checkbox-group v-model="activiteApList" style="display: inline-block; margin-right: 50px;">
          <el-checkbox v-for="(item, index) in optionsApList" :label="item.value" :key="index">
            {{ item.label}}
            <input type="text" v-model="activiteApInputNum" v-if="item.type === '1'" autocomplete="off" placeholder=""
              class="ph-input" />
            {{(item.label1 && item.type === '1') ? item.label1 : ''}}
          </el-checkbox>
        </el-checkbox-group>
        <br>
        <el-input rows="3" type="textarea" placeholder="下单备注" v-model="payNote" maxlength="100"
          show-word-limit></el-input>
      </div>
    </el-card>
    <el-row v-if="dfhchecked" type="flex" class="row-bg" justify="end">
      <el-col :span="16"></el-col>
      <el-col :span="8">
        <h1>运费：<span style="color: #F56C6C !important;">{{ expenses1 }} </span>元</h1>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-col :span="16"></el-col>
      <el-col :span="8">
        <h1>应付总金额：<span style="color: #F56C6C !important;">{{ (cartTotalPrice*1+expenses1*1).toFixed(2) }} </span>元</h1>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-col :span="20"></el-col>
      <el-col :span="2">
        <el-button type="info" @click="$router.push('/shopCart')">返回购物车</el-button>
      </el-col>
      <el-col :span="3">
        <el-button type="danger" v-if="loading" @click="goPay">确认订单</el-button>
        <el-button type="danger" v-else :disabled="true" :loading="true">确认订单中。。。</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { getAction, postAction, deleteAction } from "../../api/index";
import { selectAllocationRequirementsList, getApStr1 } from "../../utils/index"
import VDistpicker from "v-distpicker";
// let checkPhone = (rule, value, callback) => {
//   let reg = /^1[3456789]\d{9}$/;
//   if (!reg.test(value)) {
//     callback(new Error("请输入正确的手机号!"));
//   } else {
//     callback();
//   }
// };
export default {
  data() {
    return {
      loading: true,
      currentAddress: null, //选中地址高亮
      addressList: [],
      orderArr: [],
      orderInfo: [],
      cartTotalPrice: 0,
      cartTotalMPrice: 0,
      cartTotalVipPrice: 0,
      cartTotalShopPrice: 0,
      cartTotalNum: 0,
      //以下是地址的增查改所需的参数
      dfhchecked: false,
      isdfht: true,
      isdfh: false,
      options: null,
      currentRow: 0,
      payType: "1",
      payNote: "",
      labelNote: "",
      orderCompany: "",
      companyOptions: [],
      currUserNumber: this.$store.state.userInfo.userNumber,
      dictProps: {
        value: 'value',
        label: 'text',
        options: 'options',
        disabled: 'disabled',
      },
      textarea: "",
      select: { province: "", city: "", area: "" },
      ruleForm: {
        consignee: "",
        mobile: "",
        address: "",
        zipcode: "",
        province: "",
        city: "",
        county: "",
        provinceText: "",
        cityText: "",
        districtText: "",
        expenses: 0,
      },
      expenses1: 0,
      firstHeavyExpenses:0,
      firstHeavyCount:0,
      rules: {
        mobile: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          // {
          //   type: "number",
          //   validator: checkPhone,
          //   message: "请输入正确的手机号",
          //   trigger: "blur",
          // },
        ],
        district: [{ required: true, message: "请选择地区", trigger: "blur" }],
        consignee: [
          { required: true, message: "请输入收货人", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
      textAdd: {},
      url: {
        queryUserAddress: "/users/queryUserAddressByUserId",
        hasNoOrder: "/order/hasNoOrder",
        addOrder: "/order/addOrder",
        getFreight: "/order/getFreight",
        deleteCart: "/cart/deleteCartByOrderId",
        queryCartList: "/cart/queryCartList",
        getCompanyList: "/common/getDictItems/order_company",
      },
      optionsApList: selectAllocationRequirementsList(),
      activiteApList: [],
      activiteApInputNum: 0,
    };
  },
  components: { VDistpicker },
  created() {
    console.log(this.$route.params);
    this.orderArr = this.$route.params.selectGoodsList;
    this.cartTotalPrice = this.$route.params.cartTotalPrice;
    this.cartTotalMPrice = this.$route.params.cartTotalMPrice;
    this.cartTotalMarketPrice = this.$route.params.cartTotalMarketPrice;
    this.cartTotalShopPrice = this.$route.params.cartTotalShopPrice;
    this.cartTotalNum = this.$route.params.cartTotalNum;
    // 控制头部和尾部显示隐藏
    this.$store.state.showH = true;
    this.$store.state.showF = true;
    this.getAddressList();
    // this.getCompanyList();
  },
  methods: {
    onchange(val) {
      // 数据归零
      this.labelArray = [];
      console.log(val);
      this.selectedOptions = val;
      // 获取选中的label值
      this.getLabel(0, this.selectedOptions, this.options);
      console.log(this.labelArray);
    },
    // 获取label值
    getLabel(level = 0, item, opt) {
      opt.forEach((val) => {
        if (val.value == item[level]) {
          console.log(1);
          this.labelArray.push(val.label);
          level++;
          if ("children" in val) {
            this.getLabel(level, item, val.children);
          }
        }
      });
      return null;
    },
    close() {
      // 关闭
      this.dialogFormVisible = false;
    },
    getCompanyList() {
      getAction(this.url.getCompanyList).then((res) => {
        if (res.data.success) {
          this.companyOptions = res.data.result;
        }
      });
    },
    getAddressList() {
      getAction(this.url.queryUserAddress, {
        uid: this.$store.state.userInfo.id,
      }).then((res) => {
        if (res.data.success) {
          this.addressList = res.data.result;
          this.currentAddress = this.addressList[0];
        }
      });
    },
    addressAddPanel() {
      this.isEdit = false;
      for (let k in this.form) {
        this.form[k] = "";
      }
      this.dialogFormVisible = true;
    },
    // 修改地址
    // addressEditPanel(id) {
    //   console.log(id);
    //   this.isEdit = true;
    //   this.dialogFormVisible = true;
    //   let i = this.userAddress.findIndex((item) => {
    //     return item.form.id == id;
    //   });
    //   for (let k in this.form) {
    //     this.form[k] = this.userAddress[i].form[k];
    //   }
    //   formData.id = id;
    // },
    // edit() {
    //   for (let k in this.form) {
    //     formData[k] = this.form[k];
    //   }
    //   console.log(this.form);
    //   this.$store.commit("address/editAddress", {
    //     form: formData,
    //     label: this.labelArray,
    //   });
    //   this.dialogFormVisible = false;
    //   formData = {};
    // },
    getCurrentRow(row) {
      console.log(row);
      this.currentAddress = row;
    },
    isdaifahuo(val) {
      console.log("val :>> ", val);
      if (val) {
        this.isdfht = false;
        this.isdfh = true;
      } else {
        this.isdfht = true;
        this.isdfh = false;
      }
    },
    // 立即下单
    goPay() {
      //先检查用户是否有未支付的订单，给出提醒
      // getAction(this.url.hasNoOrder, {
      //   userId: this.$store.state.userInfo.id,
      // }).then((res) => {
      //   if (res.data.success) {
      //     //提示未支付的订单
      //     if (res.data.result === 1) {
      //       this.$notify({
      //         title: "温馨提示",
      //         message: "您还有未支付的订单，请及时确认！",
      //         duration: 0,
      //         type: "warning",
      //       });
      //     }
      //   }
      // });
      let addressInfo;
      let isdaifa;
      let flag = false;
      if (this.dfhchecked) {
        //代发货
        if(!this.expenses1){
          this.$message({
            type: "warning",
            message: "代发货运费不能为0，清联系管理员！",
          });
          return;
        }

        addressInfo = this.ruleForm;
        isdaifa = 1;
        //代发货校验收货信息的填写
        this.$refs["ruleForm"].validate((valid) => {
          flag = valid;
        });
      } else {
        addressInfo = this.currentAddress;
        isdaifa = 0;
      }
      if (!flag && isdaifa === 1) {
        return;
      }
      this.loading = false;
      // 生成下单时间
      let orderTime = new Date();
      let order_id = this.random_No(5, orderTime);
      // let cartTotalPrice = this.cartTotalPrice;
      this.saveOrder(order_id, addressInfo, isdaifa, orderTime);
    },
    saveOrder(orderId, addressInfo, isdaifa) {
      const that = this
      if(!addressInfo){
        addressInfo = {}
      }
      var apVal = getApStr1(that.activiteApList, that.activiteApInputNum)
      let objData = {
        orderSn: orderId,
        userId: that.$store.state.userInfo.id,
        userName: that.$store.state.userInfo.userName,
        userNumber: that.$store.state.userInfo.userNumber,
        payStatus: 0,
        consignee: addressInfo.consignee,
        country: 1,
        province: addressInfo.province,
        city: addressInfo.city,
        district: addressInfo.district,
        provinceText: addressInfo.provinceText,
        cityText: addressInfo.cityText,
        districtText: addressInfo.districtText,
        address: addressInfo.address,
        zipcode: addressInfo.zipcode,
        mobile: addressInfo.mobile,
        goodsAmount: that.cartTotalNum * 1,
        shippingFee: addressInfo.expenses,
        payNote: apVal + that.payNote,
        labelNote: that.labelNote,
        orderCompany: that.orderCompany,
        isdaifa: isdaifa,
        firstHeavyExpenses: that.firstHeavyExpenses,
        firstHeavyCount: that.firstHeavyCount,
        expenses: that.expenses1,
        orderMoneyOriginal: that.cartTotalMPrice,
        orderMoney: that.cartTotalPrice,
        orderProductList: that.orderArr,
      };
      postAction(that.url.addOrder, objData).then((res) => {
        if (res.data.success) {
          that.$message.success("订单已确认,请尽快付款！");
          //订单生成后，删除购物车对应的图书
          that.delShopCart(orderId);
          that.$router.push({
            path: "/confirmOrder",
            params: {
              orderId,
              addressInfo,
              cartTotalPrice:this.cartTotalPrice,
              orderArr: this.orderArr,
              payType: this.payType,
              isdaifa: isdaifa,
              payNote: objData.payNote,
              labelNote: objData.labelNote
            },
            name: "支付订单",
          });
        }
      });
    },
    delShopCart(orderId) {
      // let ids = [];
      // this.orderArr.forEach((item) => {
      //   ids.push(item.id);
      // });
      // deleteAction(this.url.deleteCart, { ids: ids.join(",") }).then((res) => {
      //   console.log(res.data.result);
      //   this.getCartItems();
      // });

      if (!orderId) return;
      deleteAction(this.url.deleteCart, { uid: this.$store.state.userInfo.id, orderId: orderId }).then((res) => {
        console.log(res.data.result);
        this.getCartItems();
      });
    },
    goOrder() {
      console.log("用户有未支付的订单");
      this.$store.commit("hasLogin");
      if (!this.isNaName) {
        // this.$router.push("/user/myorder");
      } else {
        this.tologin();
      }
    },
    // 判断是否是数值
    myIsNaN(value) {
      return typeof value === "number" && !isNaN(value);
    },
    // 生成订单号
    random_No(j, date) {
      var random_no = "";
      for (
        var i = 0;
        i < j;
        i++ //j位随机数，用以加在时间戳后面。
      ) {
        random_no += Math.floor(Math.random() * 6);
      }
      random_no = date.getTime() + random_no;
      // eslint-disable-next-line no-unused-vars
      return random_no;
    },
    inputChangeAddrFunc(val) {
      if (val.indexOf(',') > 0 || val.indexOf('，') > 0) {
        let addr = val.replaceAll(" ", "");
        this.textarea = addr;
      }
    },
    text() {
      var addrVal = this.textarea
      if (addrVal.indexOf(',') > 0 || addrVal.indexOf('，') > 0) {
        addrVal = addrVal.replaceAll(" ", "");
      }

      // console.log("addrVal===========",addrVal);
      this.textAdd = this.smartParse(addrVal);
      console.log("textAdd===========",this.textAdd);
      this.$set(this.ruleForm, "consignee", this.textAdd.name);
      this.$set(this.ruleForm, "mobile", this.textAdd.phone);
      let addr = this.textAdd.address;
      if (this.textAdd.street){
        addr = this.textAdd.street + this.textAdd.address;
      }
      this.$set(this.ruleForm, "address", addr);
      this.$set(this.ruleForm, "zipcode", this.textAdd.zipCode);
      // this.$set(this.ruleForm, "isDefault", this.isdefault);

      //将值填充到form表单里，同时填充省市区下拉选
      this.$set(this.ruleForm, "province", this.textAdd.provinceCode);
      this.$set(this.ruleForm, "city", this.textAdd.cityCode);
      this.$set(this.ruleForm, "district", this.textAdd.countyCode);
      this.$set(this.select, "province", this.textAdd.province);
      this.$set(this.select, "city", this.textAdd.city);
      this.$set(this.select, "district", this.textAdd.county);

      console.log(this.ruleForm);
    },
    onSelected(data) {
      console.log("data :>> ", data);
      // this.ruleForm.province = data.province.code;
      // this.ruleForm.provinceText = data.province.value;
      // this.ruleForm.city = data.city.code;
      // this.ruleForm.cityText = data.city.value;
      // this.ruleForm.district = data.area.code;
      // this.ruleForm.districtText = data.area.value;

      this.$set(this.ruleForm, "provinceText", data.province.value);
      this.$set(this.ruleForm, "cityText", data.city.value);
      this.$set(this.ruleForm, "districtText", data.area.value);
      this.$set(this.ruleForm, "province", data.province.code);
      this.$set(this.ruleForm, "city", data.city.code);
      this.$set(this.ruleForm, "district", data.area.code);
      this.$set(this.select, "province", data.province.value);
      this.$set(this.select, "city", data.city.value);
      this.$set(this.select, "district", data.area.value);
      let cityCode = data.city.code;
      console.log("cityCode============", cityCode);
      if (cityCode == 310100){
        cityCode = 310000
      }
      //请求后台获取运费
      getAction(this.url.getFreight, {
        cityCode: cityCode,
        orderNumber: this.cartTotalNum,
      }).then((res) => {
        if (res.data.success) {
          let resultMap = res.data.result;
          this.$set(this.ruleForm, "expenses", resultMap.expenses);
          this.expenses1 = resultMap.expenses;
          this.firstHeavyExpenses = resultMap.firstHeavyExpenses;
          this.firstHeavyCount = resultMap.firstHeavyCount;
        }
      });
    },
    getCartItems() {
      //获取购物车信息,并存入vuex
      getAction(this.url.queryCartList, {
        uid: this.$store.state.userInfo.id,
      }).then((ret) => {
        if (ret.data.success) {
          this.$store.state.shopCart = ret.data.result;
          window.sessionStorage.setItem(
            "shopCart",
            JSON.stringify(ret.data.result)
          );
        }
      });
    },
  },
  computed: {
    ...mapState("address", {
      userAddress: (state) => state.userAddress,
    }),
    ...mapGetters(["isNaName"]),
    fulladdress: function() {
      let str = "";
      this.userAddress[this.currentAddress].label.forEach((item) => {
        str += item + " ";
      });
      return `${str} ${this.userAddress[this.currentAddress].form.textarea}`;
    },
  },
};
</script>

<style lang="scss" scoped>
$mainColor: #ff6700;
.clearfix {
  h1 {
    // height: 45px;
    // line-height: 45px;
    font-size: 18px;
    color: #333;
  }
  h2 {
    // height: 45px;
    // line-height: 45px;
    font-size: 16px;
    color: #333;
  }
  .el-checkbox-button:last-child .el-checkbox-button__inner {
    border-left: 1 !important;
    border-radius: 4px 4px 4px 4px;
  }
}
  .el-checkbox-button__inner {
    background: #f56c6c;
  }


.row-bg {
  div {
    text-align: end;
  }
  h1 {
    font-size: 18px;
    color: #333;
  }
}
.total {
  h2 {
    color: #333;
    font-size: 15px;
    .red {
      color: #f56c6c;
    }
  }
}
.checkout-main {
  // background-color: #FFFFFF;
  // margin-bottom: 60px;
  .checkout-detail {
    .detail-section {
      .address-header {
        margin-bottom: 12px;
        .header-title {
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          color: #333333;
        }
      }
      .address-list {
        .address-item {
          position: relative;
          float: left;
          margin-right: 17px;
          margin-bottom: 17px;
          width: 270px;
          height: 180px;
          border: 1px solid #e0e0e0;
          padding: 15px 24px;
          box-sizing: border-box;
          position: relative;
          cursor: pointer;
          .address-info {
            color: #757575;
            .name {
              width: 100%;
              height: 30px;
              line-height: 30px;
              font-size: 18px;
              color: #333;
              margin-bottom: 10px;
              span {
                font-size: 14px;
                float: right;
                color: #757575;
              }
            }
            .tel {
              line-height: 23px;
            }
            .address-con {
              line-height: 23px;
              .info {
                display: block;
              }
            }
            .address-action {
              position: absolute;
              bottom: 15px;
              right: 24px;
              span {
                font-size: 14px;
                color: $mainColor;
              }
            }
          }
          .add-desc {
            position: absolute;
            display: inline-block;
            text-align: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .icon-plus {
              transition: opacity 0.1s linear;
              font-size: 30px;
              color: #b0b0b0;
              opacity: 0.5;
            }
            span {
              width: 70px;
              display: block;
              color: #757575;
              font-size: 14px;
            }
          }
          &:hover {
            .add-desc {
              .icon-plus {
                opacity: 1;
              }
            }
          }
        }
        .active {
          border: 1px solid $mainColor;
        }
      }
    }
    .detail-section {
      padding: 0 24px;
      .detail-header {
        height: 45px;
        line-height: 45px;
        font-size: 18px;
        color: #333;
      }
      .goods-list {
        .good-item {
          height: 46px;
          line-height: 46px;
          padding: 10px 0;
          .good-img {
            display: inline-block;
            margin-right: 10px;
            line-height: 46px;
            img {
              vertical-align: middle;
              display: inline-block;
              height: 30px;
              width: 30px;
            }
          }
          .good-name {
            width: 650px;
            float: left;
            a {
              font-size: 14px;
              span {
                color: #333;
              }
            }
          }
          .item-desc {
            float: left;
            .special-handling-differentiate {
              width: 440px;
              text-align: center;
              .good-price {
                float: left;
                width: 150px;
              }
              .good-total {
                float: right;
                width: 190px;
              }
            }
          }
        }
      }
    }
    .detail-section {
      padding: 0 24px;
      .section-options {
        border-top: 1px solid #e0e0e0;
        padding: 20px 0;
        line-height: 55px;
        .options-desc {
          .title {
            height: 55px;
            font-size: 18px;
            color: #333;
            width: 150px;
          }
        }
        .options-desc {
          .options-list {
            .options-item {
              float: left;
              color: $mainColor;
              margin-right: 15px;
            }
          }
        }
        .options-header {
          float: left;
        }
        .options-body {
          float: left;
        }
      }
    }
    .detail-section {
      padding: 0 24px;
      .section-discount {
        float: left;
        .discount-coupon {
          a {
            height: 50px;
            line-height: 50px;
            .icon-plus {
              color: $mainColor;
              margin-left: 10px;
            }
            span {
              color: #757575;
              font-size: 14px;
            }
          }
        }
        .position-box {
          display: inline-block;
          .discount-ecard {
            .coupon-title {
              height: 50px;
              line-height: 50px;
              .icon-plus {
                color: $mainColor;
                margin-left: 10px;
              }
              span {
                color: #757575;
                font-size: 14px;
              }
            }
          }
        }
      }
      .section-bill {
        position: absolute;
        bottom: 20px;
        right: 0;
        .bill-item {
          text-align: right;
          line-height: 30px;
          .bill-name {
            float: left;
            width: 90px;
            color: #757575;
          }
          .bill-money {
            float: left;
            color: $mainColor;
            width: 110px;
          }
        }
        .total-price {
          .bill-name {
            margin-top: 7px;
          }
          .bill-money {
            vertical-align: baseline;
            em {
              font-size: 30px;
            }
          }
        }
      }
    }
    .count-detail {
      position: relative;
      min-height: 200px;
      padding: 20px 0;
      margin: 0 48px;
    }
    .detail-section {
      .footer-address {
        float: left;
        .selecter-address {
          display: inline-block;
          color: #333;
          // .address-name {
          // }
          .address-desc {
            span {
              margin-right: 10px;
            }
            a {
              color: $mainColor;
            }
          }
        }
      }
      .handle-action {
        float: right;
        .operating-button {
          a {
            display: block;
            float: left;
            margin-left: 30px;
            text-align: center;
            line-height: 40px;
            width: 160px;
            height: 40px;
            color: #fff;
            background-color: $mainColor;
          }
          a.buy_now {
            background-color: #fff;
            border: 1px solid #b0b0b0;
            color: #b0b0b0;
          }
        }
      }
    }
    .footer-detail {
      padding: 20px 48px;
      height: 80px;
      box-sizing: border-box;
      border-top: 2px solid #f5f5f5;
    }
  }
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.ph-input{
  width: 50px;
  height: 20px;
  border: 1px solid #5d5f63;
}
</style>
